import React, { ReactNode } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectProps,
  FormHelperText,
} from "@mui/material";
import { useFormContext, Controller, RegisterOptions } from "react-hook-form";

type FormSelectProps = Omit<SelectProps, "name"> & {
  name: string;
  label?: string;
  rules?: RegisterOptions;
  required?: boolean;
  validation?: RegisterOptions;
  helperText?: string;
  children: ReactNode;
};

export default function FormSelect({
  name,
  label,
  rules,
  required,
  validation,
  helperText,
  children,
  ...rest
}: FormSelectProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldError = errors[name];

  return (
    <FormControl fullWidth error={!!fieldError} size={rest.size}>
      {label && <InputLabel id={`${name}-label`}>{label}</InputLabel>}
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? "This field is required" : false,
          ...rules,
          ...validation,
        }}
        render={({ field }) => (
          <Select {...field} {...rest} displayEmpty>
            {children}
          </Select>
        )}
      />
      <FormHelperText>
        {fieldError ? String(fieldError.message) : helperText}
      </FormHelperText>
    </FormControl>
  );
}
